export default "__VITE_ASSET__XjtbyiWq__"